import { render, staticRenderFns } from "./read-more.vue?vue&type=template&id=6e54097f&scoped=true&"
import script from "./read-more.vue?vue&type=script&lang=js&"
export * from "./read-more.vue?vue&type=script&lang=js&"
import style0 from "./read-more.vue?vue&type=style&index=0&id=6e54097f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e54097f",
  null
  
)

export default component.exports